//
import { required, number } from '@/services/validations'
import HrPreviredMutual from '@/models/HumanResource/HrPreviredMutual'
//

//
//import StockAdjustDetailHeaders from "./headers"

//
export default [
    {
        name: 'hr_previred_mutual_id',
        type: 'autocomplete-model',
        flex: {
            sm12: true,
            //lg3: true,
        },
        props: {
            itemText: 'description',
            itemValue: 'id',
            label: 'Mutual',
            loadingText: 'Cargando mutual previred...',
            model: HrPreviredMutual,
            noDataText: 'Sin mutual previred.',
            noObject: true,
            rules: [required],
        },
    },
    // {
    //     name: "wh_product_to_repackage_id",
    //     type: "autocomplete-model",
    //     flex: {
    //         sm6: true,
    //         lg3: true,
    //     },
    //     props: {
    //         itemText: "name",
    //         itemValue: "id",
    //         label: "Producto",
    //         loadingText: "Cargando productos...",
    //         model: ProductModel,
    //         noDataText: "Sin productos.",
    //         noObject: true,
    //         paramSearch: "search",
    //         rules: [ required ],
    //     },
    //     trigger ( ctx ) {

    //         //
    //         const wh_product_selected = ctx.getInput( "wh_product_to_repackage_id" ).getSelected()

    //         //
    //         if ( Array.isArray( wh_product_selected.repacking_children ) ) {
    //             ctx.value.wh_selected_products = wh_product_selected.repacking_children.map( item => {
    //                 return {
    //                     ...item,
    //                     ...item.wh_item,
    //                     ...item.wh_item.wh_product,
    //                     quantity: 0,
    //                 }
    //             })
    //         } else {
    //             ctx.value[ "wh_selected_products" ] = []
    //         }

    //         //
    //         ctx.value.wh_item_to_repackage_id = wh_product_selected.wh_item_id
    //     },
    // },
    {
        name: 'quotation_rate',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Taza de Cotización',
            rules: [required, number],
            //type:'number',
        },
    },
    {
        name: 'branch_office_code',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Codigo Sucursal Mutual',
            rules: [required, number],
            //type:'number',
        },
    },
    // {
    //     name: "wh_warehouse_to_id",
    //     type: "autocomplete-model",
    //     flex: {
    //         sm6: true,
    //         lg3: true,
    //     },
    //     props: {
    //         itemText: "name",
    //         itemValue: "id",
    //         label: "Destino",
    //         loadingText: "Cargando bodegas...",
    //         model: WarehouseModel,
    //         noDataText: "Sin bodegas.",
    //         noObject: true,
    //         rules: [ required ],
    //     },
    // },

    // {
    //     name: "comment",
    //     type: "textarea",
    //     flex: {
    //         xs12: true,
    //     },
    //     props: {
    //         label: "Comentario",
    //         rules: [ required ],
    //     },
    // },
    // {
    //     name: "is_opened",
    //     type: "switch",
    //     flex: {
    //         xs12: true,
    //     },
    //     props: {
    //         label: "El producto se encuentra abierto.",
    //         rules: [ required ],
    //     },
    // },
]
